import React from 'react';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../data/content';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function Volumes() {
  return <section className="bg-white px-4 py-14 md:py-20" data-id="element-259" data-mp="1845906jvguy3">
      <div className="mx-auto max-w-6xl" data-id="element-260" data-mp="185gafzpuhqm1">
        <Eyebrow data-id="element-261" data-mp="1c57ayv56bl3r">What's inside the system</Eyebrow>
        <SectionTitle data-id="element-262" data-mp="1c607l3af4u86">
          6 volumes. 52 weeks. <Mark data-id="element-263" data-mp="1zvb1q1x9jqdc">156 complete classes.</Mark>
        </SectionTitle>

        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-264" data-mp="1zvunxuty50x6">
          {volumes.map(volume => <article key={volume.number} className="flex flex-col rounded-2xl border border-charcoal/10 bg-ivory p-6" data-id="element-265" data-mp="24rs33xth418d">
              <span className="self-start rounded-md px-2.5 py-1 font-display text-xs font-black uppercase tracking-wider text-white" style={{
            backgroundColor: volume.color
          }} data-id="element-266" data-mp="1vt7q9dalgls2">
                Volume {volume.number}
              </span>
              <h3 className="mt-3 min-h-[3.2rem] font-display text-xl font-black uppercase leading-tight text-charcoal" data-id="element-267" data-mp="kby9wzmri9uz">
                {volume.name}
              </h3>
              <p className="mt-1 text-xs font-bold uppercase tracking-wide text-charcoal/60" data-id="element-268" data-mp="3jawp6aasoca7">
                {volume.weeks} • {volume.classes}
              </p>
              <ul className="mt-4 space-y-1.5 text-sm text-charcoal" data-id="element-269" data-mp="3t70127vg7pac">
                {volume.includes.map(item => <li key={item} className="flex gap-2" data-id="element-270" data-mp="b0bvyi0ef24o">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest" aria-hidden="true" data-id="element-271" data-mp="62tkokywsati" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}